import { SessionStorage } from '@pp/core/src/storage/session/SessionStorage';
import { SESSION_KEYS } from '@pp/core/src/templateScripts/scripts/bundleLoader/types';
import { DEFAULT_LANGUAGE_CODE } from '@pp/core/src/utils/language';

import type { LauncherTableInfo } from '../context/types';

import { LOCAL_DEV_LOBBY_URL } from './constants';

const isProduction = process.env.NODE_ENV === 'production';

export function getUniqueId(): string {
  return Math.random().toString(36).substring(2, 9);
}

export function getLauncherLobbyURL(tableUrl: string, hiddenGamesOperatorIds: string): string {
  let lobbyUrl = isProduction
    ? window.location.origin + '/desktop/lobby2/?'
    : LOCAL_DEV_LOBBY_URL + '/desktop/lobby2/?';
  const uniqueId = getUniqueId();
  const searchParams = new URL(tableUrl).searchParams;
  const language = SessionStorage.getJson<{ lang: string }>(SESSION_KEYS.GAME);
  searchParams.set('lang', language?.lang ?? DEFAULT_LANGUAGE_CODE);
  searchParams.forEach((value, key) => {
    if (key === 'table_id' || key === 'lobbyGameSymbol' || key === 'tables') {
      lobbyUrl += '';
    } else if (key === 'gametype') {
      lobbyUrl += '&gametype=baccarat';
    } else {
      lobbyUrl += '&' + key + '=' + searchParams.get(key);
    }
  });
  lobbyUrl += `&mode=launcher&forceCategory=BACCARAT&hiddenGames=${hiddenGamesOperatorIds}&launcherId=${uniqueId}`;
  return lobbyUrl;
}

export function getLobbyURL(tableUrl: string): string {
  let lobbyUrl = isProduction
    ? window.location.origin + '/desktop/lobby2/?'
    : LOCAL_DEV_LOBBY_URL + '/desktop/lobby2/?';
  const searchParams = new URL(tableUrl).searchParams;
  searchParams.forEach((value, key) => {
    if (key === 'table_id' || key === 'lobbyGameSymbol' || key === 'tables') {
      lobbyUrl += '';
    } else if (key === 'gametype') {
      lobbyUrl += '&gametype=baccarat';
    } else {
      lobbyUrl += '&' + key + '=' + searchParams.get(key);
    }
  });
  lobbyUrl += '&forceCategory=BACCARAT';
  return lobbyUrl;
}

export function getBCTableUrl(tableId: string, tables: LauncherTableInfo[]): string {
  const existingTableUrl = tables[0].url;
  const urlref = new URL(existingTableUrl);
  const params = new URLSearchParams(urlref.search);

  params.set('table_id', tableId);

  const tableUrl = urlref.href + params.toString();
  return tableUrl;
}
